import { jsxs as l, jsx as o } from "react/jsx-runtime";
const L = ({
  width: r,
  height: t,
  className: C
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: C,
    fill: "none",
    height: t,
    viewBox: "0 0 21 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M17.6803 14.377L17.3597 15.7676C17.2941 16.0513 17.0416 16.252 16.7503 16.252H4.25031C3.95906 16.252 3.70656 16.0513 3.64094 15.7676L3.32031 14.377H17.6803Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M19.2347 7.64316L17.9691 13.1275H3.03158L1.76595 7.64316C1.71033 7.40128 1.80283 7.14878 2.0022 7.00065C2.2022 6.85253 2.47033 6.83691 2.68533 6.96003L6.55345 9.17065L9.9797 4.03128C10.0916 3.86378 10.2766 3.76003 10.4772 3.75253C10.6797 3.74378 10.8703 3.83503 10.9935 3.99378L15.0116 9.16003L18.2785 6.98253C18.4916 6.84128 18.7697 6.84253 18.9803 6.98816C19.1916 7.13378 19.2916 7.39378 19.2347 7.64316Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  L as Content
};
